import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const EventDetailsActiveColumns: DataGridActiveColumns = {
  EventId: false,
  EventDescription: true,
  EventSeverity: false,
  MachineName: true,
  IpAddress: false,
  EventSource: true,
  EventStatus: true,
  EventTimeStamp: true,
  LoggedinUser: true,
  Type: false,
  Parameters: false,
  ExecutionTime: true,
};

export const EventDetailHeaders = [
  {
    caption: 'TimeStamp',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'EventTimeStamp',
    dataType: 'datetime',
  },
  {
    caption: 'Source',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'EventSource',
    dataType: 'string',
    width: 350,
  },
  {
    caption: 'Description',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'EventDescription',
    dataType: 'string',
    width: 530,
  },
  {
    caption: 'Status',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'EventStatus',
    dataType: 'string',
  },
  {
    caption: 'Execution Time',
    allowFiltering: true,
    alignment: 'center',
    dataField: 'ExecutionTime',
    dataType: 'string',
  },
  {
    caption: 'Machine',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'MachineName',
    dataType: 'string',
  },
  {
    caption: 'User',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'LoggedinUser',
    dataType: 'string',
  },
];

export const EventDetailsBaseColumns = {
  EventTimeStamp: {
    field: 'Event TimeStamp',
    filterPlaceholder: 'Search TimeStamp',
    template: 'DateTimeTpl',
    Filter: 'DateFilter',
  },
  EventSource: {
    field: 'EventSource',
    filterPlaceholder: 'Search Source',
    width: 350,
  },
  EventDescription: {
    field: 'EventDescription',
    filterPlaceholder: 'Search Description',
    width: 530,
  },
  EventStatus: {
    field: 'EventStatus',
    filterPlaceholder: 'Search Status',
  },
  ExecutionTime: {
    field: 'ExecutionTime',
    filterPlaceholder: 'Search Time',
  },
  MachineName: {
    field: 'MachineName',
    filterPlaceholder: 'Search Machine',
  },
  EventId: {
    field: 'EventId',
    filterPlaceholder: 'Search Event Id',
  },
  EventSeverity: {
    field: 'Event Severity',
    filterPlaceholder: 'Search Event Severity',
  },
  LoggedinUser: {
    field: 'LoggedinUser',
    filterPlaceholder: 'Search Loggedin User',
  },
  Parameters: {},
};
